var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33.709,
    viewBox: "0 0 32 33.709",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    id: "featured_seasonal_and_gifts_24dp_FILL0_wght200_GRAD0_opsz24",
    d: "M122.188-844.751V-863.9H120v-7.863h9.142a2.452,2.452,0,0,1-.733-1.112,4.454,4.454,0,0,1-.2-1.35,4.088,4.088,0,0,1,1.236-3,4.088,4.088,0,0,1,3-1.236,3.765,3.765,0,0,1,1.877.48,5.044,5.044,0,0,1,1.473,1.249,4.92,4.92,0,0,1,1.474-1.255,3.8,3.8,0,0,1,1.877-.475,4.088,4.088,0,0,1,3,1.236,4.088,4.088,0,0,1,1.236,3,4.323,4.323,0,0,1-.208,1.339,2.594,2.594,0,0,1-.728,1.123H152v7.863h-2.188v19.145Zm16.957-31.932a2.381,2.381,0,0,0-1.754.708,2.381,2.381,0,0,0-.708,1.754,2.381,2.381,0,0,0,.708,1.754,2.381,2.381,0,0,0,1.754.708,2.381,2.381,0,0,0,1.754-.708,2.382,2.382,0,0,0,.708-1.754,2.381,2.381,0,0,0-.708-1.754A2.382,2.382,0,0,0,139.145-876.682Zm-9.162,2.461a2.382,2.382,0,0,0,.708,1.754,2.381,2.381,0,0,0,1.754.708,2.381,2.381,0,0,0,1.754-.708,2.382,2.382,0,0,0,.708-1.754,2.382,2.382,0,0,0-.708-1.754,2.382,2.382,0,0,0-1.754-.708,2.381,2.381,0,0,0-1.754.708A2.381,2.381,0,0,0,129.983-874.221Zm-8.205,4.24v4.308h13.333v-4.308Zm13.333,23.453V-863.9H123.966v17.368Zm1.778,0h11.145V-863.9H136.889Zm13.333-19.145v-4.308H136.889v4.308Z",
    transform: "translate(-120 878.46)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBox);
export default __webpack_public_path__ + "static/media/giftBox.527647024f8ff59c634c596f8e14673e.svg";
export { ForwardRef as ReactComponent };